<template>
    <p class="control has-icon has-icon-right" :class="'control-' + id">
        <input @click="inputClicked()" :type="options.inputtype || 'text'" :id="id" :name="id" :autocomplete="autocomplete" class="input" :value="filteredValue" @input="onInputChanged($event.target.value)" :maxlength="getMaxLength()" :class="{ 'is-danger' : error }" :placeholder="placeholder" :min="options.min !== null && options.min !== undefined ? options.min : ''" :max="options.max !== null && options.max !== undefined ? options.max : ''" :step="options.step || ''" />
        <slot></slot>
        <span class="icon is-small" v-if="error">
            <i class="fa fa-warning"></i>
        </span>
        <span class="help is-danger" v-if="error" v-html="$options.filters.toList(error)"></span>
    </p>
</template>

<script>
    import Vue from 'vue';
    import filters from '../../../filters';
    import { Tracking } from '../../../utils';

    export default {
        name: 'form-input',

        props: {
            id: {
                type: String,
            },
            value: {
                type: String,
            },
            autocomplete: {
                type: String,
            },
            options: {
                type: Object,
                'default': () => { return {}; },
            },
            placeholder: {
                type: String,
                'default': '',
            },
            error: {
                'default': false,
            },
        },

        filters: filters,

        created() {
        },

        computed: {
            filteredValue() {
                if(!this.value) {
                    return '';
                }
                if(this.options.iban) {
                    return this.formatIban();
                }
                if(this.options.inputtype && this.options.inputtype === 'url') {
                    return this.formatUrl();
                }
                return this.value;
            },

            inputElement() {
                try {
                    return this.$el.getElementsByTagName('input')[0];
                } catch (e) {
                    return null;
                }
            },
        },

        methods: {
            onInputChanged(v) {
                let pos = this.getCursorPosition();

                if(!v) {
                    this.$emit('input', '');
                }
                if(this.options.uppercase) {
                    v = v.toUpperCase();
                }
                if(this.options.iban) {
                    v = v.replace(/\s+/g, '').toUpperCase().substr(0, 22);
                }
                this.$emit('input', v);

                if(v !== this.inputElement.value && pos !== null) {
                    Vue.nextTick(() => {
                        if(pos.isAtEnd) {
                            pos = {
                                start: this.inputElement.value.toString().length,
                                end: this.inputElement.value.toString().length,
                            };
                        }
                        this.setCursorPosition(pos);
                    });
                }
            },

            formatIban() {
                let a = this.value.replace(/\s+/g, '').substr(0, 22).toUpperCase().split('');
                let v = '';
                let i = 1;
                while(a.length) {
                    v += a.shift().toString();
                    if(i % 4 === 0) {
                        v += ' ';
                    }
                    i++;
                }
                return v;
            },

            formatUrl() {
                const v = this.value;
                const a = ['h', 'ht', 'htt', 'http', 'https', 'http:', 'https:', 'http:/', 'https:/', 'http://', 'https://'];
                const check = (val) => {
                    const v1 = v.toLocaleLowerCase().substr(0, 7);
                    const v2 = v.toLocaleLowerCase().substr(0, 8);
                    if(val === v1 || val === v2) {
                        return true;
                    }
                    return false;
                };

                if(!a.some(check)) {
                    return `http://${v}`;
                }
                return v;
            },

            getMaxLength() {
                if(this.options.maxlength) {
                    return Number(this.options.maxlength);
                }
                if(this.options.iban) {
                    return 27;
                }
                return null;
            },

            getCursorPosition() {
                const input = this.inputElement;
                if(!input) {
                    return null;
                }
                try {
                    if(input.selectionStart && document.activeElement === input) {
                        return {
                            start: input.selectionStart,
                            end: input.selectionEnd,
                            isAtEnd: input.selectionStart === input.selectionEnd && input.selectionEnd === input.value.toString().length
                        };
                    } else if(input.createTextRange) {
                        let sel = document.selection.createRange();
                        if(sel.parentElement() === input) {
                            let rng = input.createTextRange();
                            rng.moveToBookmark(sel.getBookmark());
                            let len;
                            for(len = 0; rng.compareEndPoints('EndToStart', rng) > 0; rng.moveEnd('character', -1)) {
                                len++;
                            }
                            rng.setEndPoint('StartToStart', input.createTextRange());
                            let pos;
                            for(pos = { start: 0, end: len }; rng.compareEndPoints('EndToStart', rng) > 0; rng.moveEnd('character', -1)) {
                                pos.start++;
                                pos.end++;
                            }

                            pos.start = Math.max(0, Math.min(pos.start, input.value.toString().length));
                            pos.end = Math.max(0, Math.min(pos.end, input.value.toString().length));
                            pos.isAtEnd = pos.start === pos.end && pos.start === input.value.toString().length;
                            return pos;
                        }
                    }
                } catch (e) {
                    return null;
                }

                return null;
            },

            setCursorPosition(pos) {
                try {
                    const input = this.inputElement;
                    input.focus();
                    input.setSelectionRange(pos.start, pos.end);
                } catch (e) {}
            },

            inputClicked() {
                Tracking.trackEvent('Settings', 'formField', this.id, null);
            }
        },
    };
</script>

<style lang="scss">
    @import 'forminput.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/forminput/forminput.vue